/* B2C API wrapper — isolated from institutional axios instance. */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const B2C_API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: B2C_API,
  withCredentials: true,
});

export const avanzoApi = {
  access:      () => client.get("/avanzo-b2c/access"),
  summary:     () => client.get("/avanzo-b2c/me/summary"),
  subscription:() => client.get("/avanzo-b2c/subscription"),
  bankSummary: () => client.get("/avanzo-b2c/bank-summary"),

  trainingNext:  (body = {}) => client.post("/avanzo-b2c/training/next", body),
  trainingAnswer:(body) => client.post("/avanzo-b2c/training/answer", body),

  trainingSessionStatus:    () => client.get("/avanzo-b2c/training/session/status"),
  trainingSessionHeartbeat: (body) => client.post(
    "/avanzo-b2c/training/session/heartbeat", body),
  trainingSessionWarnAck:   (body) => client.post(
    "/avanzo-b2c/training/session/warning-ack", body),
  trainingSessionFinish:    (body) => client.post(
    "/avanzo-b2c/training/session/finish", body),

  // Fase 6 — Simulacro 1
  simulation1Status:  () => client.get("/avanzo-b2c/simulation-1/status"),
  simulation1Start:   () => client.post("/avanzo-b2c/simulation-1/start", {}),
  simulation1Current: () => client.get("/avanzo-b2c/simulation-1/current"),
  simulation1Answer:  (body) => client.post("/avanzo-b2c/simulation-1/answer", body),
  simulation1Result:  () => client.get("/avanzo-b2c/simulation-1/result"),

  // Fase 7 — Simulacro Final
  finalSimulationStatus:  () => client.get("/avanzo-b2c/final-simulation/status"),
  announcementStatus:     (key) => client.get(`/avanzo-b2c/announcements/${key}`),
  announcementSeen:       (key) => client.post(`/avanzo-b2c/announcements/${key}/seen`),
  finalSimulationStart:   () => client.post("/avanzo-b2c/final-simulation/start", {}),
  finalSimulationCurrent: () => client.get("/avanzo-b2c/final-simulation/current"),
  finalSimulationAnswer:  (body) => client.post("/avanzo-b2c/final-simulation/answer", body),
  finalSimulationResult:  () => client.get("/avanzo-b2c/final-simulation/result"),

  progressEligibility: () => client.get("/avanzo-b2c/progress-check/eligibility"),
  progressStart:       () => client.post("/avanzo-b2c/progress-check/start", {}),
  progressStatus:      () => client.get("/avanzo-b2c/progress-check/status"),
  progressCurrent:     () => client.get("/avanzo-b2c/progress-check/current"),
  progressAnswer:      (body) => client.post("/avanzo-b2c/progress-check/answer", body),
  progressResult:      (runId) => client.get(
    `/avanzo-b2c/progress-check/result${runId ? `?run_id=${runId}` : ""}`),

  // Fase 8 — Modo del día (NORMAL / FINAL_REINFORCEMENT / EXAM_DAY / POST_AVANZO)
  trainingMode: () => client.get("/avanzo-b2c/training/mode"),

  // Retroalimentación pedagógica al final de una sesión (determinístico, 0 LLM)
  trainingReview: (sessionId) =>
    client.get(`/avanzo-b2c/training/session/${sessionId}/review`),

  // Fase 8.1 — Buddy Reflection Layer (determinístico, 0 LLM)
  buddyStatus: (sessionId = "") => client.get(
    `/avanzo-b2c/buddy/reflection/status${sessionId ? `?session_id=${sessionId}` : ""}`),
  buddyStart:   (body) => client.post("/avanzo-b2c/buddy/reflection/start", body || {}),
  buddyRespond: (body) => client.post("/avanzo-b2c/buddy/reflection/respond", body),
  buddyHelpful: (body) => client.post("/avanzo-b2c/buddy/reflection/helpful", body),

  // Fase 8.2 — Buddy Tutor Mode (guided problem solving, 0 LLM por defecto)
  tutorStatus:  (params) => client.get("/avanzo-b2c/buddy/tutor/status", { params }),
  tutorStart:   (body) => client.post("/avanzo-b2c/buddy/tutor/start", body),
  tutorRespond: (body) => client.post("/avanzo-b2c/buddy/tutor/respond", body),
  tutorHint:    (body) => client.post("/avanzo-b2c/buddy/tutor/hint", body),
  tutorFinish:  (body) => client.post("/avanzo-b2c/buddy/tutor/finish", body),
  tutorHelpful: (body) => client.post("/avanzo-b2c/buddy/tutor/helpful", body),

  finalWindows:     () => client.get("/avanzo-b2c/final-simulation/windows"),
  finalEligibility: () => client.get("/avanzo-b2c/final-simulation/eligibility"),

  parentChildren: () => client.get("/avanzo-b2c/parent/children"),

  // ── Fase 3/4 — PAES 2026 TRAIN v2 + Buddy Tutor v2 ──
  paesConfig:          () => client.get("/avanzo-b2c/paes/config"),
  paesHomeToday:       () => client.get("/avanzo-b2c/paes/home/today"),
  paesProgressBands:   () => client.get("/avanzo-b2c/paes/progress/bands"),
  paesCatalogSubjects: () => client.get("/avanzo-b2c/paes/catalog/subjects"),
  paesCatalogHabilidades: (subject) => client.get(
    `/avanzo-b2c/paes/catalog/habilidades${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`),
  paesSessionStart:    (body = {}) => client.post("/avanzo-b2c/paes/session/start", body),
  paesSessionGet:      (id) => client.get(`/avanzo-b2c/paes/session/${id}`),
  paesSessionNext:     (id) => client.post(`/avanzo-b2c/paes/session/${id}/next`),
  paesSessionAnswer:   (id, body) => client.post(
    `/avanzo-b2c/paes/session/${id}/answer`, body),
  paesTutorHelp:       (body) => client.post("/avanzo-b2c/paes/tutor/help", body),
  // Fase 6.2 — onboarding tour
  paesOnboardingStatus:   () => client.get("/avanzo-b2c/paes/onboarding/status"),
  paesOnboardingComplete: () => client.post("/avanzo-b2c/paes/onboarding/complete", {}),
  paesOnboardingDismiss:  () => client.post("/avanzo-b2c/paes/onboarding/dismiss", {}),
  paesOnboardingReopen:   () => client.post("/avanzo-b2c/paes/onboarding/reopen", {}),
};

/** Localized labels for the 4-stage PAES v2 progress bar. */
export const PAES_STAGE_LABELS = {
  activation: "Activación",
  guided: "Con Buddy",
  variable_practice: "Práctica",
  avanzo_challenge: "Reto AVANZO",
  closing: "Cierre",
};

/** Localized labels for feedback levels (never expose raw keys to UI). */
export const FEEDBACK_TITLES = {
  hint: "Pista",
  guided_explanation: "Veámoslo juntos",
  explicit_teaching: "Aprendamos esta idea",
  acknowledgement: "",
};

/** Friendly copy for the adaptive selector's `reason_selected`. */
export const REASON_COPY = {
  new_skill_diagnostic: "Nueva habilidad",
  low_mastery:          "Vamos a fortalecer",
  recurrent_error:      "Retomemos con calma",
  stagnant:             "Nuevo enfoque",
  no_transfer_yet:      "Aplica lo aprendido",
  maintain_competence:  "Mantén tu ritmo",
  general_practice:     "Práctica",
  spaced_revisit:       "Retomemos brevemente una habilidad que practicamos antes",
};

// M2.2 · Teacher B2B read-only endpoint
export function teacherStudentsProgress() {
  return client.get("/avanzo-b2c/teacher/students-progress");
}

export function formatSeconds(total) {
  const s = Math.max(0, Math.floor(total || 0));
  const m = Math.floor(s / 60);
  const rest = s % 60;
  if (m === 0) return `${rest}s`;
  return `${m}m ${rest}s`;
}
